module.exports = __webpack_public_path__ + "img/queue_card_disabled.ec9dd313.svg";